import Card from 'app/components/Card';
import { URLS } from 'app/config/urls';
import { useSubheader } from 'app/context/SubheaderContext';
import React, { useLayoutEffect } from 'react';
import { useIntl } from 'react-intl';
import Description from './components/Description';
import ConfigurationForm from './components/ConfigurationForm';

export default function Configuration() {
  const intl = useIntl();
  const subheader = useSubheader();
  const { setTitle, setIcon, setBreadcrumbs } = subheader;

  useLayoutEffect(() => {
    setTitle(
      intl.formatMessage({ id: 'controlpanel.asidemenu.configuration' })
    );
    setIcon({ icon: 'gear' });
    setBreadcrumbs([
      {
        pathname: URLS.orders,
        title: intl.formatMessage({
          id: 'controlpanel.asidemenu.orders'
        })
      },
      {
        pathname: `${URLS.orders}/${URLS.ordersConfig}`,
        title: intl.formatMessage({
          id: 'controlpanel.asidemenu.configuration'
        })
      }
    ]);
  }, [intl, setTitle, setBreadcrumbs, setIcon]);

  return (
    <Card
      body={
        <>
          <Description />
          <ConfigurationForm />
        </>
      }
    />
  );
}
